export const requestComboboxOptionHoverClassName = 'hover:bg-primary/10';

export const requestComboboxSelectClassNames = {
    input: 'cursor-pointer',
    option: `${requestComboboxOptionHoverClassName} cursor-pointer [&[data-combobox-active]]:bg-primary/10`,
} as const;
